import React, { useState } from "react";
import axios from "axios";
import { IoClose } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const UserAddressForm = ({ onClose, address }) => {
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const token = localStorage.getItem("token");
  console.log("hello ", address);
  const [formData, setFormData] = useState({
    full_name: "",
    mobile_number: "",
    pin_code: "",
    full_address: "",
    state: "",
    city: "",
    near_by_address: "",
    alternate_mobile_number: "",
    deliveryOption: "home",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = async (e) => {
    const { name, value } = e.target;

    if (name === "mobile_number" || name === "alternate_mobile_number") {
      if (/^\d*$/.test(value) && value.length <= 10) {
        setFormData((prevState) => ({ ...prevState, [name]: value }));
      }
    } else if (name === "pin_code") {
      if (/^[0-9]{1,6}$/.test(value)) {
        setFormData((prevState) => ({ ...prevState, [name]: value }));

        if (value.length === 6) {
          console.log(value);
          try {
            const response = await fetch(
              `https://api.postalpincode.in/pincode/${value}`
            );
            const data = await response.json();

            setFormData((prevState) => ({
              ...prevState,
              state: data[0]?.PostOffice[0]?.State || "",
              city: data[0]?.PostOffice[0]?.Region || "",
            }));
          } catch (error) {
            console.error("Error fetching PIN code data", error);
            alert("Enter correct PIN Code");
          }
        }
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const validateForm = () => {
    let errors = {};
    if (!formData.full_name) errors.full_name = "Full name is required.";
    if (!/^[\d]{10}$/.test(formData.mobile_number))
      errors.mobile_number = "Valid mobile number is required.";
    if (!formData.pin_code) errors.pin_code = "Pin code is required.";
    if (!formData.city) errors.city = "City is required.";
    if (!formData.state) errors.state = "State is required.";
    if (!formData.full_address) errors.full_address = "Address is required.";
    if (!formData.near_by_address)
      errors.near_by_address = "Near by address is required.";
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      console.log("userId===================>     ", userId, "saffdag ", formData);
      await axios.post(
        `${process.env.REACT_APP_PUBLIC_API_BASE_URL}user/user_id_${userId}/shipping-address`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );



      onClose();

    } catch (error) {
      console.error("Error adding address", error);
    }

    setFormData({
      full_name: "",
      mobile_number: "",
      pin_code: "",
      full_address: "",
      state: "",
      city: "",
      near_by_address: "",
      alternate_mobile_number: "",
      deliveryOption: "home",
    });
  };

  return (

    <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 w-full max-w-lg rounded-2xl shadow-xl relative ">
        <button
          className="absolute top-4 right-4 text-gray-500 hover:text-red-500 transition duration-200 text-2xl"
          onClick={onClose}
        >
          <IoClose />
        </button>

        <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
          Add New Address
        </h2>

        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 gap-4">
            <div className="grid grid-cols-2 gap-4">
              <div className="flex flex-col gap-1">
                <input
                  type="text"
                  placeholder="Enter Name"
                  name="full_name"
                  value={formData.full_name}
                  onChange={handleChange}
                  className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-400 outline-none"
                />
                {errors.full_name && (
                  <span className="text-sm text-red-500">{errors.full_name}</span>
                )}
              </div>
              <div className="flex flex-col gap-1">
                <input
                  type="text"
                  placeholder="Mobile No"
                  name="mobile_number"
                  value={formData.mobile_number}
                  onChange={handleChange}
                  className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-400 outline-none"
                />
                {errors.mobile_number && (
                  <span className="text-sm text-red-500">{errors.mobile_number}</span>
                )}
              </div>
            </div>

            <div className="flex flex-col gap-1">
              <textarea
                placeholder="Enter your address"
                name="full_address"
                value={formData.full_address}
                onChange={handleChange}
                rows={3}
                className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-400 outline-none resize-none"
              />
              {errors.full_address && (
                <span className="text-sm text-red-500">{errors.full_address}</span>
              )}
            </div>

            <div className="flex flex-col gap-1">
              <input
                type="text"
                placeholder="Landmark"
                name="near_by_address"
                value={formData.near_by_address}
                onChange={handleChange}
                className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-400 outline-none"
              />
              {errors.near_by_address && (
                <span className="text-sm text-red-500">{errors.near_by_address}</span>
              )}
            </div>

            <div className="flex flex-col gap-1">
              <input
                type="text"
                placeholder="PinCode"
                name="pin_code"
                value={formData.pin_code}
                onChange={handleChange}
                className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-400 outline-none"
              />
              {errors.pin_code && (
                <span className="text-sm text-red-500">{errors.pin_code}</span>
              )}
            </div>

            <div className="grid grid-cols-2 gap-4">
              <input
                type="text"
                placeholder="City"
                name="city"
                value={formData.city}
                onChange={handleChange}
                className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-400 outline-none"
              />
              <input
                type="text"
                placeholder="State"
                name="state"
                value={formData.state}
                onChange={handleChange}
                className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-400 outline-none"
              />
            </div>

            <input
              type="text"
              placeholder="Alternate Phone (optional)"
              name="alternate_mobile_number"
              value={formData.alternate_mobile_number}
              onChange={handleChange}
              className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-400 outline-none"
            />

            <button
              type="submit"
              disabled={loading}
              className="bg-gradient-to-r from-blue-500 to-blue-700 text-white font-semibold py-2 rounded-lg shadow hover:shadow-md transition-all duration-200"
            >
              {loading ? "Submitting..." : "Deliver Here"}
            </button>
          </div>
        </form>
      </div>
    </div>

  );
};

export default UserAddressForm;
